import React, { useState, useEffect } from "react"
import * as S from "./header.styles.jsx"
import Logo from "../../assets/logo.svg"
import WhiteLogo from "../../assets/white-logo.svg"
import HEADER_ITEMS from "./header-items.json"
import { useScrollTrigger, useMediaQuery, Box } from "@mui/material"
import MenuIcon from "../../assets/header-menu.svg"
import CloseIcon from "../../assets/header-close.svg"
import ArrowIcon from "../../assets/header-arrow.svg"
import HeaderMobile from "./header-mobile/header-mobile.component.jsx"
import { useTheme } from "@emotion/react"
import { isBrowser } from "../../utils/utils.js"

const Header = ({ transparent, whiteHeader }) => {
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up("md"))
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  const tooltip = isBrowser ? document.querySelector("#tcWidgetTooltip") : null

  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  })

  const handleOpenMenu = () => {
    setIsOpenMenu(!isOpenMenu)
  }

  useEffect(() => {
    // console.log("tooltip :>> ", tooltip)
    if (!upMd) {
      if (tooltip) {
        tooltip.style.transition = "0.5s ease-in-out"
        setTimeout(() => {
          tooltip.style.visibility = "hidden"
          tooltip.style.opacity = "1"
          tooltip.style.zIndex = "-1"
        }, 5000)
      }
    } else {
      if (tooltip) {
        tooltip.style.transition = "0.5s ease-in-out"
        tooltip.style.visibility = "visible"
        tooltip.style.opacity = "0"
        tooltip.style.zIndex = "1"
      }
    }
  }, [tooltip])

  useEffect(() => {
    setIsOpenMenu(false)
  }, [upMd])

  useEffect(() => {
    const tooltip = document.querySelector("#tcWidgetTooltip")
    if (tooltip) {
      if (isOpenMenu) {
        tooltip.style.zIndex = "-1"
      } else {
        tooltip.style.zIndex = "1"
      }
    }
    const widget = document.querySelector("#tcWidgetBtn")
    if (widget) {
      if (isOpenMenu) {
        widget.style.zIndex = "-1"
      } else {
        widget.style.zIndex = "1"
      }
    }
  }, [isOpenMenu])

  return (
    <S.Header
      elevation={scrollTrigger ? 4 : 0}
      className={`${isOpenMenu ? "open" : ""} ${
        transparent ? "transparent" : ""
      } ${whiteHeader ? "white" : ""}`}
    >
      <S.Wrapper maxWidth="xl">
        <S.LogoWrapper url={"/"}>
          {isOpenMenu || scrollTrigger ? (
            <Logo />
          ) : whiteHeader ? (
            <WhiteLogo />
          ) : (
            <Logo />
          )}
        </S.LogoWrapper>
        <Box display="flex">
          <S.LinksWrapper>
            {HEADER_ITEMS.map((item, index) => {
              const Link = item.url ? S.Link : S.StyledText
              return (
                <S.LinkWrapper key={`header-item-${index}`}>
                  <Link
                    url={item.url}
                    className={`parent ${item.items ? "hasSub" : ""}`}
                  >
                    {item.title}
                  </Link>
                  {item.items && <ArrowIcon className="arrow" />}
                  {item.items && (
                    <S.SubItemsWrapper className="subitems">
                      {item?.items?.map(({ title, url }, index) => (
                        <S.SubLink url={url} key={`sub-item-${index}`}>
                          {title}
                        </S.SubLink>
                      ))}
                    </S.SubItemsWrapper>
                  )}
                </S.LinkWrapper>
              )
            })}
            <S.LinkWrapper>
              <S.Link
                url="https://earnest.titleoneusa.com/"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                Submit earnest money
              </S.Link>
            </S.LinkWrapper>
          </S.LinksWrapper>
          <S.ButtonsWrapper className="buttons-wrapper">
            <S.StyledBtn href="/get-started">Get started now</S.StyledBtn>
          </S.ButtonsWrapper>
        </Box>
        <S.MenuBtn onClick={handleOpenMenu}>
          {isOpenMenu ? <CloseIcon /> : <MenuIcon className="menu" />}
        </S.MenuBtn>
      </S.Wrapper>
      <HeaderMobile isOpen={isOpenMenu} handleClose={handleOpenMenu} />
    </S.Header>
  )
}
export default Header
